import { IListItem } from '../_Core/CoreTypes';

export interface IDashboardInfo {
  categories: IListItem[];
  entryTypes: IListItem[];

  warnings: IWarningData[];
  quickAccess: IQuickAccess[];

  genderStats: IStatData[];
  categoryStats: IStatData[];
  entryStats: IStatData[];
  gradeStats: IStatData[];
  orderStats: IStatData[];
}

export interface IWarningData {
  Text: string;
  Level: WarningDataLevel;
  Link?: string;
  LinkText: string;
  Target?: string;
  BranchId?: string;
}

export enum WarningDataLevel {
  Info = 100,
  Warning = 1000,
  Critical = 10000,
  New = 20000,
}

export interface IStatData {
  Label: string;
  Value: number;
  StringValue: string;
  X: number;
  Y: number;
}

export interface IQuickAccess {
  ClassName: string;
  Icon: string;
  Label: string;
  Link: string;
  LinkText: string;
  Target?: string;
  Description: string;
}
